/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenter } from '../../models/work-center';

export interface GetWorkCenters$Params {
      body: Array<number>
}

export function getWorkCenters(http: HttpClient, rootUrl: string, params: GetWorkCenters$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkCenter>>> {
  const rb = new RequestBuilder(rootUrl, getWorkCenters.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkCenter>>;
    })
  );
}

getWorkCenters.PATH = '/api/v1/WorkCenter';
